<script>
import GlobalVue from '@root/helper/Global.vue';
import "@backend/dist/js/sidebarmenu.js";
import BoConfig from '@root/config/BoConfig';
import BOGen from '@helper/BOGen';

var $ = window.$

export default {
  name: "SideBar",
  extends: GlobalVue,
  data(){
    return {
      show: false,
      isDefaultPassword: false,
      gaForm: [],
      notifyOnboardingChecklist: false
    }
  },
  computed:{
    menus(){
      return BoConfig.sidebar
    },    
  },
  mounted(){
    setTimeout(()=>{ this.init() }, 10)
    this.getProfile()
    this.getGAForm()

    this.checkOnboardingChecklist()
  },
  methods:{
    init(){
      $("#sidebarnav .child2").each((k,el)=>{
        if(!$(el).find("a").length){
          $(el).closest("li").remove()
        }
      })
      $("#sidebarnav .child1").each((k,el)=>{
        if(!$(el).find("a").length){
          $(el).closest("li").remove()
        }
      })
      // this.initActive()
      this.show = true
    },
    // initActive(){
    //   $("#sidebarnav li").removeClass("active")
    //   $(".router-link-exact-active").closest("li").addClass("active")
    //   $(".router-link-exact-active").closest('.child1').closest("li").addClass("active")
    // },
    logout(){
      this.page.logout()
    },
    linkRoute(link){
      let l = this.$router.resolve({name: link});
      if( l.resolved.matched.length > 0) return {name:link}
      return {path:link}
    },
    haveTargetBlank(link){
      if(link.indexOf("http")==-1) return false
      return link.indexOf(location.host)>-1 ? false : "_blank"
    },
    isShow(v){
      if(v.link == "#") return true
      return this.isMenu(v.link)
    },
    getProfile(){
      BOGen.apirest('/ProfileCheck', { cwid: this.user.cwid }, (err, resp) => {
        if(err) return console.error(err);

        this.isDefaultPassword = resp.isDefaultPassword
      })
    },
    getGAForm(){
      BOGen.apirest('/GetActiveForm', { cwid: this.user.cwid }, (err, resp) => {
        if(err) return console.error(err);

        this.gaForm = resp.data
      })
    },
    checkOnboardingChecklist(){
      BOGen.apirest('/GetOnboardingChecklist', { cwid: this.user.cwid }, (err, resp) => {
        if(err) return console.error(err);

        if(resp.totalChecklist) this.notifyOnboardingChecklist = true
      })
    },
    checkRejectedAdditionalFacility(){
      if(this.user.additional_rejected == true) return true
      return false
    },
    menuNeedNotify(menu){
      const menus = [
        "OnboardingChecklist",
      ]

      return menus.indexOf(menu) >= 0;
    }
  },
  watch:{
    // "$route.path"(v){
    //   setTimeout(()=>{ this.initActive() }, 30)
    // }
  }
}
</script>

<template>
  <span>
    <aside class="left-sidebar">
      <!-- Sidebar scroll-->
      <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
          <ul id="sidebarnav" v-show="show">
            <li class="user-pro">
              <a class="has-arrow waves-effect waves-dark" href="javascript:;" aria-expanded="false">
                <span class="hide-menu">{{user.employeename}} ({{user.al_name}})</span>
              </a>
              <ul aria-expanded="false" class="collapse">              
                <li><a href="javascript:;" @click="logout()"><i class="fa fa-power-off"></i> Logout</a></li>
              </ul>
            </li>
            <li class="nav-small-cap">--- Navigation Menu</li>
            <li v-for="(v,k) in menus" :key="k" :class="$route.meta.group  ? v.group == $route.meta.group ? 'active' : '' : v.link == $route.name ? 'active' : ''">
              <router-link v-if="!v.childs&&isShow(v)" class="waves-dark" :to="linkRoute(v.link)"><i :class="v.icon"></i>
                              
                <div class="inbox-pointer" v-if="checkRejectedAdditionalFacility() && v.link == 'AdditionalFacility'"></div>                
                <div class="inbox-pointer" v-if="notifyOnboardingChecklist && menuNeedNotify(v.link)"></div>                
                <span class="hide-menu">{{v.name}}  

                  <!-- <span class="badge badge-pill badge-cyan ml-auto">4</span> -->
                </span>
              </router-link>
              <template v-else-if="v.childs">
                <a class="has-arrow waves-effect waves-dark" href="javascript:;" aria-expanded="false">
                  <i :class="v.icon"></i>
                  <span class="hide-menu">{{v.name}}</span>
                </a>
                <ul aria-expanded="false" class="collapse child1">
                  <li v-for="(v2,k2) in v.childs" :key="k2" :disabled="v2.withLock&&isLockAuthorization">
                    <a v-if="v2.withLock&&isLockAuthorization"> {{v2.name}}</a>
                    <router-link :class="v2.link == $route.name ? 'active-list-menu' : ''" v-else-if="!v2.childs&&isShow(v2)" :to="linkRoute(v2.link)"> {{v2.name}} </router-link>
                    <template v-else-if="v2.childs">
                      <a class="has-arrow waves-effect waves-dark" href="javascript:;" aria-expanded="false">
                        <span class="hide-menu">{{v2.name}}</span></a>
                      <ul aria-expanded="false" class="collapse child2">
                        <li v-for="(v3,k3) in v2.childs" :key="k3">
                          <router-link v-if="isShow(v3)" :to="linkRoute(v3.link)"> {{v3.name}}</router-link>
                        </li>
                      </ul>
                    </template>
                  </li>
                </ul>
              </template>
            </li>

            <li v-if="(gaForm||[]).length">
              <a class="has-arrow waves-effect waves-dark" href="javascript:;" aria-expanded="false">
                <i :class="`ti-layout-grid2`"></i>
                <span class="hide-menu">Form GA</span>
              </a>
              <ul aria-expanded="false" class="collapse child1">
                <li v-for="(v2,k2) in gaForm" :key="k2">
                  <a :href="v2.ga_form_link" target="_blank">{{v2.ga_form_name}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- End Sidebar navigation -->

      </div>
      <!-- End Sidebar scroll-->
    </aside>
    
    
    <div class="container-fluid" v-if="isDefaultPassword">
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="alert alert-danger w-100" role="alert">
            <b class="fw-500">Warning!</b> To protect your account, please change your password <router-link :to="{name: 'Profile'}">here</router-link>.

            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>